import { setCookie } from "@/lib/setCookie";
import { reset } from "@/redux/slices";
import { RootState } from "@/redux/store";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);

  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  const handleClose = () => setIsOpen(false);

  const onLogoutClick = () => {
    setIsLogoutOpen(true);
  };

  const onLogout = () => {
    dispatch(reset());
    setCookie("accessToken", "");
    navigate(`/`, { replace: true });
  };

  return {
    isOpen,
    onLogoutClick,
    handleClose,
    setIsOpen,
    isLogoutOpen,
    setIsLogoutOpen,
    onLogout,
    isProfileMenuOpen,
    setIsProfileMenuOpen,
    loggedInUserData,
  };
};

export default useHeader;
